import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useCart } from '../../contexts/CartContext';

export default function Navbar() {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const { getTotalItems } = useCart();

  // Safely obtain cart item count with fallback
  const cartItemCount = typeof getTotalItems === 'function' ? getTotalItems() : 0;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-3">
        <div className="flex items-center justify-between">
          <a href="/" className="flex items-center space-x-3 relative">
            <div className="h-14 flex items-center overflow-visible">
              <img
                src="https://static.readdy.ai/image/64f7aba38830139cff78662b39218feb/e8b5985a2853ff72499d68992cdf2c3a.png"
                alt="YourTime Logo"
                className="h-40 w-auto max-w-none"
              />
            </div>
          </a>

          <div className="flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/') ? 'text-teal-600' : 'text-gray-700 hover:text-teal-600'
              }`}
            >
              Home
            </Link>
            <Link
              to="/catalog"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/catalog') ? 'text-teal-600' : 'text-gray-700 hover:text-teal-600'
              }`}
            >
              Catalog
            </Link>
            <Link
              to="/customizer"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/customizer') ? 'text-teal-600' : 'text-gray-700 hover:text-teal-600'
              }`}
            >
              Customizer
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/about') ? 'text-teal-600' : 'text-gray-700 hover:text-teal-600'
              }`}
            >
              About
            </Link>
            <Link
              to="/contact"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/contact') ? 'text-teal-600' : 'text-gray-700 hover:text-teal-600'
              }`}
            >
              Contact
            </Link>

            <Link to="/cart" className="relative cursor-pointer">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-shopping-cart-line text-2xl text-gray-700 hover:text-teal-600 transition-colors"></i>
              </div>
              {cartItemCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-teal-600 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                  {cartItemCount}
                </span>
              )}
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
